import { render, staticRenderFns } from "./AddCityDialog.vue?vue&type=template&id=36c1215f&"
import script from "./AddCityDialog.vue?vue&type=script&lang=js&"
export * from "./AddCityDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports